import Spinner from './spinner';

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/index.js